/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export interface IResponseInterceptor {
        response: Function;
        responseError: Function;
    }

    export interface IRequestInterceptor {
        request: Function;
        requestError: Function;
    }

    export class BreezeInterceptor implements IResponseInterceptor {
        public static factory( growl: angular.growl.IGrowlService,
            $q: ng.IQService) {
            return new BreezeInterceptor(growl,$q);
        }

        constructor( private growl: angular.growl.IGrowlService,
            private $q: ng.IQService) {
        }

        public response = (responseSuccess): ng.IPromise<any> => {
            if (responseSuccess.status === 200 && responseSuccess.data != null && responseSuccess.data.Errors != null) {
                for (var i = 0; i < responseSuccess.data.Errors.length; i++) {
                    console.info(responseSuccess.data.Errors[i]);
                    this.growl.error(responseSuccess.data.Errors[i].ErrorMessage);
                }
            }
            return responseSuccess;
        }

        public responseError = (responseFailure): ng.IPromise<any> => {
            return this.$q.reject(responseFailure);
        }
    }
}

warsApp.registerService('BreezeInterceptor', ['growl', '$q']);